import { render, staticRenderFns } from "./WardImportRequestContacts.vue?vue&type=template&id=64639a9e&"
import script from "./WardImportRequestContacts.vue?vue&type=script&lang=js&"
export * from "./WardImportRequestContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports